<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="标题">
          <el-input
            style="width: 220px"
            v-model.trim="queryForm.title"
            clearable
            placeholder="请输入标题"
            @keyup.enter.native="search"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="queryForm.status"
            clearable
            placeholder="请选择状态"
            style="width: 140px"
          >
            <el-option label="启用" :value="0"></el-option>
            <el-option label="停用" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="openForm('add')"
          >新增</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column
          align="center"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="标题"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="图片" width="120">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.imageUrl"
              :src="scope.row.imageUrl"
              :preview-src-list="[scope.row.imageUrl]"
              fit="contain"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="linkName"
          label="链接名称"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="link"
          label="跳转链接"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="sort"
          label="排序"
          width="80"
        ></el-table-column>
        <el-table-column align="center" prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="scope.row.status === 0 ? 'success' : 'info'"
            >
              {{ scope.row.status === 0 ? "启用" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="endTime"
          label="截止日期"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建时间"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              plain
              round
              size="small"
              type="primary"
              @click="openForm('edit', scope.row)"
              >编辑</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="deleteInfo(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>

    <BannerForm ref="bannerFormRef" @success="search" />
  </div>
</template>

<script>
import { getBannerList, deleteBanner } from "@/api/homepage/banner";
import BannerForm from "./BannerForm.vue";

export default {
  name: "Advertisement",
  components: {
    BannerForm
  },
  data() {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        title: "",
        status: undefined
      },
      listData: [],
      totals: 0,
      loading: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.search();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNum = 1;
      this.search();
    },
    resetSelect() {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10,
        title: "",
        status: undefined
      };
      this.search();
    },
    async search() {
      this.loading = true;
      try {
        const params = { ...this.queryForm };
        if (params.status === "" || params.status === null) {
          delete params.status;
        }
        const result = await getBannerList(params);
        const data = (result && result.data) || {};
        this.listData = data.rows || [];
        this.totals = Number(data.total) || 0;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    openForm(type, row) {
      this.$refs.bannerFormRef.open(type, row);
    },
    deleteInfo(row) {
      this.$confirm("确定要删除该广告吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            await deleteBanner(row.bannerId);
            this.$message.success("删除成功");
            this.search();
          } catch (e) {}
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/homepage/advertisement/index.vue